// import SectionList from "./SectionList.js";
// import ArticleItem from "./ArticleItem.js";

import jquery from "jquery";
import fitvids from "fitvids";
import VisibilitySensor from "react-visibility-sensor";

import React, { Component } from "react";

class ArticleItem extends Component {
  constructor(props) {
    super(props);
    // this.myRef = React.createRef();

    let pageview_tracking_sent = this.props.item.page == 0 ? true : false;
    this.state = { pageview_tracking_sent: pageview_tracking_sent };
  }

  componentDidMount() {
    // window.instgrm.Embeds.process();
    jquery(this.refs.article).html(this.props.item.html);
    // jquery(this.myRef).html(this.props.item.html);
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }

    // TODO: remove fitvids? perf issues?
    fitvids(`#${this.refs.article.id} .article-body`);
  }

  handleIsVisible = isVisible => {
    console.log("handleIsVisible: ", isVisible, this.props.item.page);

    if (isVisible) {
      let url = this.props.item.meta.permalink;
      if (this.props.initial_qs) {
        url += "?" + this.props.initial_qs;
      }
      console.log("url: ", url);
      // history.pushState(null, null, this.props.item.meta.permalink);
      history.pushState(null, null, url);

      this.sendPageviewTracking();
    }
  };

  setTrackingVars = () => {};

  sendPageviewTracking = () => {
    console.log("sendPageviewTracking");

    ga("set", "dimension1", this.props.item.meta.author);
    ga("set", "dimension2", this.props.item.meta.vertical);
    ga("set", "dimension3", this.props.item.meta.category);
    ga("set", "dimension14", this.props.item.meta.article_type);

    var postPosition = this.props.item.page;

    if (postPosition == 0) {
      return;
    }

    ga("send", {
      hitType: "event",
      eventCategory: "Article Infinite Scroll Pageview",
      eventLabel: "Scroll Position " + postPosition,
      eventValue: postPosition,
      eventAction: "event"
    });

    // this.setState({ pageview_tracking_sent: true });
  };

  render() {
    let id = `article-${this.props.item.id}`;
    return (
      <div className={this.props.itemClassName} key={this.props.item.id}>
        <VisibilitySensor
          onChange={this.handleIsVisible}
          partialVisibility={true}
        >
          <div ref="article" id={id} />
        </VisibilitySensor>
      </div>
    );
  }
}

export default ArticleItem;
